import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column" as const,
    minHeight: "80vh",
    fontFamily: "Lexend, sans-serif",
    padding: "24px",
    maxWidth: "1100px",
    margin: "0 auto",
    width: "100%",
    boxSizing: "border-box" as const,
  },
  header: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "4px",
    marginBottom: "20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "16px",
  },
  mediaCard: {
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: "#f9f9f9",
    border: "1px solid #eee",
    position: "relative" as const,
    cursor: "pointer",
    transition: "box-shadow 0.2s",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    "& video": {
      width: "100%",
      height: "150px",
      objectFit: "cover" as const,
      display: "block",
    },
    "& img": {
      width: "100%",
      height: "150px",
      display: "block",
    },
  },
  mediaCardBadge: {
    position: "absolute" as const,
    top: "6px",
    left: "6px",
    backgroundColor: "rgba(0,0,0,0.6)",
    color: "#fff",
    fontSize: "9px",
    fontFamily: "Lexend, sans-serif",
    fontWeight: 500,
    padding: "2px 6px",
    borderRadius: "4px",
    lineHeight: 1.3,
    zIndex: 1,
    maxWidth: "85%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
  },
  approvedBadge: {
    position: "absolute" as const,
    top: "6px",
    right: "6px",
    zIndex: 1,
    fontSize: "22px",
    backgroundColor: "#fff",
    borderRadius: "50%",
  },
  mediaCardInfo: {
    padding: "8px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  mediaCardPrompt: {
    fontSize: "11px",
    color: "#666",
    fontFamily: "Lexend, sans-serif",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
    flex: 1,
    minWidth: 0,
  },
  mediaCardOverlay: {
    height: "150px",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    gap: "4px",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    opacity: 0.6,
    flex: 1,
    minHeight: "200px",
  },
  emptyIcon: {
    width: "80px",
    height: "80px",
    backgroundColor: "#f5f5f5",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #ddd",
  },
  modalMediaArea: {
    width: "100%",
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "300px",
  },
  modalVideo: {
    width: "100%",
    maxHeight: "500px",
    display: "block",
  },
  modalStatusArea: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    padding: "48px",
  },
}));

export default useStyles;
